class CountryPicker extends HTMLElement {
    constructor() {
      super();
      this.detailsContainer = this.querySelector('[data-container]');
      this.toggles = this.querySelectorAll('[data-toggle]');
        
    }

    connectedCallback() {
        if(!this.detailsContainer) return;
        this.toggles.forEach(toggle => {
            toggle.addEventListener('click', () => {
                this.detailsContainer.dataset.active
                ? this.close()
                : this.open();
            });
        });

    }
  
    open() {
        this.detailsContainer.dataset.active = 'true';
    }
  
    close() {
        delete this.detailsContainer.dataset.active;
    }
  }
  
  customElements.define('country-picker', CountryPicker);
  